import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { dataReviewApi, type UpdateVariantField } from '../services/data-review';

export const useAvailableLocales = (realmId?: number) => {
  return useQuery({
    queryKey: ['data-review', 'locales', realmId],
    queryFn: () => dataReviewApi.getLocales(realmId),
    staleTime: 5 * 60 * 1000, // 5 minutes - locales don't change often
  });
};

export const useDataReviewVariants = (locale: string) => {
  return useQuery({
    queryKey: ['data-review', 'variants', locale],
    queryFn: () => dataReviewApi.getVariants(locale),
    enabled: !!locale,
  });
};

export const useUpdateVariantField = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateVariantField) => dataReviewApi.updateVariantField(data),
    onSuccess: (_, variables) => {
      // Invalidate and refetch the variants for the locale
      void queryClient.invalidateQueries({
        queryKey: ['data-review', 'variants', variables.locale]
      });
    },
  });
};
